export class MessageModel {
  type: string;
  title: string;
  body: string;
  showCloseButton: true;
}
